import { AppError } from "@/lib/utils/errors";
import { routes } from "@/lib/utils/routes";
import { employeeService } from "@/modules/services/employeeService";
import { useEmployeeInfoStore } from "@/modules/store/employeeStore";
import { redirect } from "next/navigation";
import { useAuth } from "../auth/useAuth";

export const useEmployeeInfo = (strictCheck: boolean = false) => {
  const {
    status,
    employeeInfo,
    setStatus,
    setEmployeeInfo,
    clearEmployeeInfo,
  } = useEmployeeInfoStore();
  const { logout: onLogout } = useAuth();
  const getEmployeeInfo = async () => {
    const svc = employeeService;
    setStatus("loading");
    try {
      const resp = await svc.getByDefault();
      if (resp && resp.employeeInfo) {
        setEmployeeInfo(resp.employeeInfo);
        setStatus("success");
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
      const appErr = new AppError(err);
      appErr.logError();
      // enqueueSnackbar(appErr.message, { variant: "error" });
      if (strictCheck) {
        redirect(routes.auth.login);
      }
    } finally {
      setTimeout(() => {
        setStatus("idle");
      }, 3000);
    }
  };

  const logout = async () => {
    onLogout();
    clearEmployeeInfo();
  };

  return {
    employeeInfo,
    loading: status === "loading",
    getEmployeeInfo,
    setEmployeeInfo,
    logout,
  };
};
